import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import ActionBtn from "../../../common/management/ActionBtn";

import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  name: string;
  type: string[];
  email: string;
  id: string;
  active: boolean;
};

const UserListItem: React.FC<Props> = (props) => {
  const { name, type, email, id, active } = props;

  const genType = (el: string) => {
    switch (el) {
      case "general_user":
        return "通";
      case "admin":
        return "Ｓ";
      case "company_manager":
        return "社";
      case "team_manager":
        return "チ";
      case "jikei_student":
        return "生";
      case "jikei_manager":
        return "マ";
      case "jikei_admin":
        return "管";
      default:
        break;
    }
  };

  return (
    <div
      className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["member"]}`}
    >
      <div>{name}</div>
      <div>
        {type.map((el, i) => (
          <span key={i} className={styles["userType"]}>
            {genType(el)}
          </span>
        ))}
      </div>
      <div>{email}</div>
      <ActionBtn label="ユーザー詳細" link={`/admin/member/${id}`} />
      <FontAwesomeIcon
        icon={["fas", "user-check"]}
        className={active ? styles["active"] : styles["inactive"]}
      />
    </div>
  );
};

export default UserListItem;
